import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import media from 'src/styles/media';

import imgClose from 'src/assets/images/close.svg';
import imgLogo from 'src/assets/images/618-logo-full-white.svg';

const linkItems = [
  {
    label: 'Legacy',
    to: '/legacy',
    image: require('src/assets/images/legacy/history.jpg'),
  },
  {
    label: 'Neighbourhood',
    to: '/neighbourhood',
    image: require('src/assets/images/neighbourhood/aerial.jpg'),
  },
  {
    label: 'The Building',
    to: '/building',
    image: require('src/assets/images/building/streetview.jpg'),
  },
  {
    label: 'Interiors',
    to: '/interiors',
    image: require('src/assets/images/interiors/living.jpg'),
  },
  {
    label: 'Floorplans',
    to: '/floorplans',
    image: require('src/assets/images/floorplans/hero.jpg'),
  },
  {
    label: 'Virtual Tours',
    to: '/virtualtours',
    image: require('src/assets/images/virtualtour/618_Carnarvon_Lobby_1-min.jpg'),
  },
  {
    label: 'Views',
    to: '/views',
    image: require('src/assets/images/views/hero.jpg'),
  },
  {
    label: 'Team',
    to: '/team',
    image: require('src/assets/images/team/hero.jpg'),
  },
  {
    label: 'Register',
    to: '/register',
    image: require('src/assets/images/register/hero.jpg'),
  },
];

class Menu extends Component {
  state = {
    isHover: false,
    hover: 0,
  };

  static propTypes = {
    shown: PropTypes.bool,
    menuClose: PropTypes.func,
  };

  handleMouseOver = index => {
    this.setState({ isHover: true, hover: index });
  };

  handleMouseLeave = () => {
    this.setState({ isHover: false });
  };

  renderBackground() {
    return linkItems.map((item, index) => (
      <Background
        key={index}
        active={this.state.isHover && index === this.state.hover}
        style={{
          backgroundImage: `url(${item.image})`,
        }}
      />
    ));
  }

  render() {
    const { shown, menuClose } = this.props;

    return (
      <Root shown={shown}>
        <HomeBtn to="/" onClick={menuClose}>
          <img src={imgLogo} alt="618 Carnarvon" />
        </HomeBtn>
        <NavBar>
          <StyledLink to="/" className="home-link" onClick={menuClose}>
            Home
          </StyledLink>
          {linkItems.map((item, index) => (
            <StyledLink
              key={item.label}
              to={item.to}
              onClick={menuClose}
              onMouseOver={() => this.handleMouseOver(index)}
              onMouseLeave={this.handleMouseLeave}
            >
              {item.label}
            </StyledLink>
          ))}
        </NavBar>
        {this.renderBackground()}
        <BtnClose onClick={menuClose}>
          <span>Close</span>
          <img src={imgClose} alt="Close Menu" />
        </BtnClose>
      </Root>
    );
  }
}

const Root = styled.div`
  position: fixed;
  z-index: 300;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colorPrimary};
  transition: 0.4s ease-out;
  opacity: ${props => (props.shown ? 1 : 0)};
  transform: ${props => (props.shown ? 'translateX(0)' : 'translateX(-100%)')};
`;

const NavBar = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  transition: all 0.4s ease-out;
  @media (min-width: ${media.sm}) {
    width: 80vh;
    height: 80vh;
    padding: 100px;
    justify-content: space-between;
  }
  &::before {
    content: '';
    border: 1px solid rgba(30, 70, 103, 0.28);
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 30vh;
    height: 30vh;
    background-size: cover;
    z-index: 2;
    transition: all 0.4s ease-out;
    @media (min-width: ${media.smup}) {
      width: 100%;
      height: 100%;
    }
  }
  &::after {
    content: '';
    width: 50vh;
    height: 50vh;
    border: 1px solid rgba(30, 70, 103, 0.28);
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    transition: all 0.4s ease-out;
    @media (min-width: ${media.sm}) {
      width: 110vh;
      height: 110vh;
    }
  }
  &:hover {
    > a {
      opacity: 0.68;
    }
    &::before {
      content: '';
      border: 1px solid transparent;
      background-color: ${({ theme }) => theme.colorPrimary};
    }
    &::after {
      border: 1px solid transparent;
      background-color: ${({ theme }) => theme.colorPrimary};
      opacity: 0.4;
    }
  }
`;

const HomeBtn = styled(Link)`
  position: absolute;
  top: 3%;
  left: 3%;
  display: none;
  z-index: 5;
  @media (min-width: ${media.smup}) {
    display: block;
  }
`;

const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-size: cover;
  background-color: ${({ theme }) => theme.colorPrimary};
  opacity: ${props => (props.active ? 0.4 : 0)};
  width: 100%;
  height: 100%;
  transition: all 0.8s ease-out;
`;

const BtnClose = styled.div`
  color: rgba(255, 255, 255, 0.83);
  text-transform: uppercase;
  font-size: 12px;
  font-family: ${({ theme }) => theme.fontHeader};
  background-color: ${({ theme }) => theme.colorDarkBlue};
  width: 105px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 30px;
  position: absolute;
  right: 3%;
  top: 3%;
  cursor: pointer;
  transition: 0.4s ease-out;
  &:hover {
    box-shadow: 0 0 8px 0 #0b1a27;
  }
`;

const StyledLink = styled(Link)`
  margin-bottom: 15%;
  color: white;
  text-transform: uppercase;
  font-family: ${({ theme }) => theme.fontHeader};
  font-size: 22px;
  transition: all 0.4s ease-out;
  z-index: 3;
  @media (min-width: ${media.smup}) {
    margin-bottom: 0;
  }
  &:last-child {
    color: ${({ theme }) => theme.colorDarkBlue};
  }
  &:hover {
    opacity: 1 !important;
  }
  &.home-link {
    @media (min-width: ${media.smup}) {
      display: none;
    }
  }
`;

export default Menu;



// WEBPACK FOOTER //
// ./src/components/Navigation/Menu.js